import { Reducer } from 'redux';
import MapActionTypes from './types';
import { MapState } from './types';

export const initialState: MapState = {
  mapSearchWithExtentZoom: [true]
};

const reducer: Reducer<MapState> = (state = initialState, action: any) => {
  switch (action.type) {
    case MapActionTypes.SET_IS_OPEN_BASE_MAP_PANEL:
      return {
        ...state,
        isOpenBaseMapPanel: action.payload
      };
    case MapActionTypes.SET_IS_OPEN_MAP_LOC_SEARCH_PANEL:
      return {
        ...state,
        isOpenMapLocSearchPanel: action.payload
      };
    case MapActionTypes.SET_MAP_SEARCH_WITH_EXTENT_ZOOM:
      return {
        ...state,
        mapSearchWithExtentZoom: action.payload
      };
    default:
      return state;
  }
};

export { reducer as MapReducer };
